import { render, staticRenderFns } from "./MedicationConsultation.vue?vue&type=template&id=2d082e71&scoped=true&"
import script from "./MedicationConsultation.vue?vue&type=script&lang=js&"
export * from "./MedicationConsultation.vue?vue&type=script&lang=js&"
import style0 from "./MedicationConsultation.vue?vue&type=style&index=0&id=2d082e71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d082e71",
  null
  
)

export default component.exports